import { MODAL } from '@socialive/common';
import PropTypes from 'prop-types';
import useModal from '../hooks/useModal';

const ModalProxy = ({ modalId, trigger, render: Component, ...other }) => {
  const modal = useModal({ modalId, trigger: trigger ?? Component?.name });

  // eslint-disable-next-line react/jsx-props-no-spreading
  return modal.visible ? <Component modal={modal} {...other} /> : null;
};

ModalProxy.propTypes = {
  modalId: PropTypes.oneOf(Object.values(MODAL)).isRequired,
  trigger: PropTypes.string,
  render: PropTypes.elementType.isRequired,
};

ModalProxy.defaultProps = {
  trigger: undefined,
};

export default ModalProxy;
